import { ReactNode, useState } from "react";

export interface PaymentOptionProps {
    logo?: string;
    text?: string;
    option: string;
    paymentMethod?: string;
    setPaymentMethod: (option: string) => void;
}

export const PaymentOption: React.FC<PaymentOptionProps> = ({logo, text, option, paymentMethod, setPaymentMethod}) => {

    const isSelected = paymentMethod === option;

    return (
        <div onClick={() => {setPaymentMethod(option)}} className={`${isSelected ? "border-primary border-[2px] border-opacity-50" : ""} flex h-[90px] w-[160px] rounded-xl shadow-main p-4 items-center justify-center cursor-pointer transition-all duration-40`}>
            {logo ?
                <img className={`max-h-full ${text ? text.toLowerCase().includes('swedbank') ? "scale-150" : "" : ""}`} src={logo} alt="" />
                :
                <div>{text}</div>
            }

        </div>
    )
}